'use strict';

var ActionTypes = require('../constants/ActionTypes'),
    AppDispatcher = require('../AppDispatcher'),
    ActivityAPI = require('../api/ActivityAPI'),
    ActionUtils = require('../utils/ActionUtils'),
    ActivityListStore = require('../stores/ActivityListStore');

var ActivityActionCreators = {
  requestActivityPage(isInitialRequest) {
    if (isInitialRequest) {
      AppDispatcher.handleViewAction({
        type: ActionTypes.INVALIDATE_ACTIVITIES
      });
    }

    ActionUtils.requestPage({
      isInitialRequest: isInitialRequest,
      store: ActivityListStore,
      action: ActionTypes.REQUEST_ACTIVITIES,
      callAPI: ActivityAPI.requestActivitiesPage
    });
  },

  requestUnseenCount() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.REQUEST_UNSEEN_ACTIVITY_COUNT
    });

    ActivityAPI.requestUnseenCount();
  },

  markAll() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.ACTIVITY_MARK_ALL
    });

    ActivityAPI.markAll();
  },

  expandActivity(activityId) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.ACTIVITY_EXPAND,
      activityId: activityId
    });
  },

  collapseActivity(activityId) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.ACTIVITY_COLLAPSE,
      activityId: activityId
    });
  }
};

module.exports = ActivityActionCreators;



/** WEBPACK FOOTER **
 ** ./actions/ActivityActionCreators.js
 **/